import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { useLanguage } from "@/contexts/LanguageContext";
import { Mail, MapPin, MessageSquare } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-foreground text-background">
      {/* CTA Section */}
      <div className="container mx-auto px-4 py-16"></div>

      <div className="container mx-auto px-4 pb-12">
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🐊</span>
              <span className="text-xl font-bold">Dealigator</span>
            </div>
            <p className="text-background/60 text-sm mb-4">{t.footer.brand.description}</p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t.footer.platform.title}</h4>
            <ul className="space-y-2 text-sm text-background/60">
              <li>
                <Link to="/" className="hover:text-background transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/properties" className="hover:text-background transition-colors">
                  {t.nav.deals}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-background transition-colors">
                  Услуги
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-background transition-colors">
                  {t.footer.contact.title}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t.footer.contact.title}</h4>
            <ul className="space-y-3 text-sm text-background/60">
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                {t.footer.contact.location}
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                contact@dealigator.com
              </li>
              <li>
                <Link to="/contact" className="flex items-center gap-2 hover:text-background transition-colors">
                  <MessageSquare className="h-4 w-4" />
                  {t.footer.contact.feedback}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-background/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-background/40">
          <div>© 2026 Dealigator. {t.footer.legal.rights}</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-background transition-colors">
              {t.footer.legal.privacy}
            </Link>
            <Link to="/terms" className="hover:text-background transition-colors">
              {t.footer.legal.terms}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
